import React from 'react';
import { StyledJoyLogo } from './JoyLogo.styles';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';

export const JoyLogo: React.FC = () => {
  const isMobile = useIsMobileScreen();
  const joyLogoProps = {
    height: isMobile ? 48 : 56,
    width: isMobile ? 77 : 90
  };
  return <StyledJoyLogo {...joyLogoProps} />;
};
